angular.module('homebot.directives')

.directive('homeValueChart', ['DataService', function(DataService){
  return {
    restrict: 'E',
    controllerAs: 'homeValueChartCtrl',
    bindToController: {
      homeId: '@',
      history: '='
    },
    scope: {},
    templateUrl: '/homes/templates/partials/home-value-chart.html',
    controller: function(){
      let ctrl = this;

      ctrl.setupGraph = function(){
        if(!ctrl.history) return;
        ctrl.chart = new ValueLineChart(ctrl.el).update(ctrl.history);
      };
    },
    link: function($scope, el, attrs, ctrl){
      ctrl.el = el.find('svg')[0];

      el.on('$destroy', () => {
        if(ctrl.chart)
          ctrl.chart.destroy();
      });

      $scope.$watch('homeValueChartCtrl.history', function(oldVal, newVal){
        if(oldVal !== newVal)
          ctrl.setupGraph();
      });

      ctrl.setupGraph();
    }
  }
}]);
